import { useEffect, useState } from "react";
import { focusableElements } from "../utils/focusableElements";

export default function useMobileSidebar(open, setOpen) {
    const [mobile, setMobile] = useState(() => window.matchMedia("(max-width: 1199.98px)").matches);
    useEffect(() => {
        const query = window.matchMedia("(max-width: 1199.98px)");
        const update = () => { setMobile(query.matches); if (!query.matches) setOpen(false); };
        update();
        query.addEventListener?.("change", update);
        return () => query.removeEventListener?.("change", update);
    }, [setOpen]);

    useEffect(() => {
        const sidebar = document.getElementById("layout-menu");
        if (!sidebar) return undefined;
        sidebar.inert = mobile && !open;
        sidebar.setAttribute("aria-label", "Navigation principale");
        if (mobile && !open) sidebar.setAttribute("aria-hidden", "true");
        else sidebar.removeAttribute("aria-hidden");
        if (!mobile || !open) return undefined;

        const previousFocus = document.activeElement;
        const main = document.querySelector(".workspace-main");
        const wasInert = main?.inert;
        if (main) main.inert = true;
        sidebar.setAttribute("role", "dialog");
        sidebar.setAttribute("aria-modal", "true");
        sidebar.querySelector(".sidebar-mobile-close")?.focus({ preventScroll: true });
        const onKeyDown = (event) => {
            if (event.key === "Escape") { event.preventDefault(); setOpen(false); }
            if (event.key !== "Tab") return;
            const items = focusableElements(sidebar);
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && (document.activeElement === first || !sidebar.contains(document.activeElement))) {
                event.preventDefault(); last?.focus();
            } else if (!event.shiftKey && (document.activeElement === last || !sidebar.contains(document.activeElement))) {
                event.preventDefault(); first?.focus();
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("keydown", onKeyDown);
            sidebar.removeAttribute("role");
            sidebar.removeAttribute("aria-modal");
            if (main) main.inert = wasInert;
            if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
        };
    }, [mobile, open, setOpen]);
}
